import { createContext } from "react";

export type UploadLock = {
  /** Nombre d'envois de fichiers en cours (requête partie, réponse pas encore reçue). */
  pending: number;
  /** Déclare un envoi en cours ; la fonction renvoyée le libère (à appeler dans un finally). */
  acquire: () => () => void;
};

export const UploadLockContext = createContext<UploadLock>({
  pending: 0,
  acquire: () => () => {},
});
